<template>
  <div class="wrapper">
    <header-reg-elem />
    <notification-elem />
    <router-view 
      v-if="provider.client_level"
    />
    <footer-elem />
  </div>
</template>

<script>
import HeaderReg from '@/templates/HeaderReg';
import Footer from '@/templates/Footer';
import Notification from '@/components/Notification';
import { mapGetters } from 'vuex';

export default {
  name: 'registration-tpl',
  components: {
    'header-reg-elem': HeaderReg,
    'footer-elem': Footer,
    'notification-elem': Notification,
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  }
}
</script>